import { t } from 'i18next';
import { observer } from 'mobx-react-lite';
import React from 'react';

import OrderBySelector, {
  AvailableOrderOption,
} from '~components/OrderBySelector/OrderBySelector';
import { useStores } from '~store';
import { SettlementSort } from '~store/SettlementsStore';

const orderOptions: AvailableOrderOption<SettlementSort>[] = [
  { value: SettlementSort.CREATED_AT, label: t('common.created_date') },
  { value: SettlementSort.FOR, label: t('approvals.driver_pay.settlements.for') },
];

const SettlementsOrderSelectorCTA = () => {
  const { settlementsStore } = useStores();

  return (
    <OrderBySelector
      onChange={(option) => settlementsStore.setSort(option)}
      order={settlementsStore.sortOption}
      orderOptions={orderOptions}
    />
  );
};

export default observer(SettlementsOrderSelectorCTA);
